import React, {useState} from 'react';

import {apiPostFile, getMerchantsApiUrl} from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import Strings from '../common/Strings';
import useUserContext from '../common/UserContext';

import AdminMerchantFile from '../program/MerchantFile';

export default function MerchantFile() {
 
	return (
		<><AdminMerchantFile /></>
	)
}